
(function () {
    'use strict';

    angular.module('handbookApp', ['angularTreeview', 'processModule', 'dashboardModule',
        'ui.bootstrap', 'ui.router', 'ngGrid', 'ui.tree',
        'placeholderShim', 'cfp.hotkeys', 'ngClipboard', 'dibari.angular-ellipsis', 'modelOptions', 'ngSanitize',
        'accountModule', 'customeDirectivesModule', 'PubSubModule', 'homeModule', 'configModule',
        'documentFieldsModule', 'tabModule', 'managementModule', 'newsListModule', 'feedbackModule',
        'advanceSearchModule', 'metadataSearchModule', 'smart-table', 'infinite-scroll', 'hearingFeedbackModule',
        'NewsCategoryModule', 'documentHearingFieldsModule', 'compareWithEarlierVersionModule', 'rwdImageMaps',
        'vs-repeat', 'documentCompareWithEarlierVersionModule', 'ui.grid', 'ui.grid.expandable', 'ui.grid.autoResize',
        'ui.grid.cellNav', 'highcharts-ng', 'ui.bootstrap.typeahead', 'checklistModule', 'annualCycleModule', 'ngCookies'
    ]).provider('workersPool', function workersPoolProvider() {
        var self = this;
        window.workersPool = {};
        window.workersPool['document-worker.js'] = new Worker('/workers/document-worker.js');
        window.workersPool['meta-data-document-worker.js'] = new Worker('/workers/meta-data-document-worker.js');
        this.$get = [function workersPoolFactory() {
            return window.workersPool;
        }];
    }).run(['$rootScope', '$location', '$state', '$http', function ($rootScope, $location, $state, $http) {

        if (window.customResources) {
            //console.log(JSON.stringify(window.resources).length);
            $.extend(true, window.resources, window.customResources);
            //console.log(JSON.stringify(window.resources).length);
        }

        $rootScope.resources = window.resources;
    }]);

    angular.module('printingApp', ['printingModule']);
})();